import { SidebarMenuItem } from '@builder';
import { FC, useState } from 'react';
import {
  ExpandingButtonContainerStyled,
  ExpandingButtonStyled,
  HelixBuilderLogoStyled,
  HelixLogomarkStyled,
  LinkStyled,
  MenuItemContainerStyled,
  SidebarContainerStyled,
  SidebarContentStyled,
  SidebarLogoContainerStyled,
} from './Sidebar.styles';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '@constants/routes';
import { SidebarItem, SidebarProps } from './Sidebar.types';

const Sidebar: FC<SidebarProps> = ({ locationPath, menuItems }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [isSidebarBlocked, setIsSidebarBlocked] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleMenuItemClick = (path: string): void => {
    navigate(path);
  };

  const handleExpandButtonClick = (): void => {
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
      setIsSidebarBlocked(false);
    } else {
      setIsSidebarOpen(true);
      setIsSidebarBlocked(true);
    }
  };

  const handleSidebarHoverEffect = (): void => {
    if (!isSidebarBlocked && !isSidebarOpen) {
      setIsSidebarOpen(true);
    }
  };

  const handleSidebarLeaveEffect = (): void => {
    if (!isSidebarBlocked && isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <SidebarContainerStyled data-testid="sidebar" isOpen={isSidebarOpen}>
      <SidebarContentStyled onMouseEnter={handleSidebarHoverEffect} onMouseLeave={handleSidebarLeaveEffect}>
        <SidebarLogoContainerStyled>
          <LinkStyled to={PATHS.ROOT}>
            <HelixLogomarkStyled />
            <HelixBuilderLogoStyled isOpen={isSidebarOpen} />
          </LinkStyled>
        </SidebarLogoContainerStyled>
        <MenuItemContainerStyled>
          {menuItems.map((item: SidebarItem) => (
            <SidebarMenuItem
              id={item.id}
              icon={item.icon}
              label={item.label}
              key={item.id}
              isSelected={locationPath.includes(item.url)}
              isOpen={isSidebarOpen}
              onClick={() => handleMenuItemClick(item.url)}
            />
          ))}
        </MenuItemContainerStyled>
      </SidebarContentStyled>
      <ExpandingButtonContainerStyled data-testid="sidebar-expand-button">
        <ExpandingButtonStyled isOpen={isSidebarOpen} onClick={handleExpandButtonClick} />
      </ExpandingButtonContainerStyled>
    </SidebarContainerStyled>
  );
};

export default Sidebar;
